// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6878) return "static/chunks/6878-d607a0cc58bc8daf.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3544":"ace0c3ca50ea0f0d","6875":"601cf34352fc42a5","6968":"d8df4e29b31526d8"}[chunkId] + ".js";
};